/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Modal, List, Divider, Skeleton } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { AccountModalProps } from '../ts-config';
import cs from 'classnames';
import { tntPageList } from '@/common/api/common';
import styles from './index.module.less';
import { isArray, isMobile, isNotEmptyAny } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useMethods } from '@lhb/hook';
import { getLocxxExpansionReturnPath } from '@/common/config/locxxExpansion';
import { switchTenant } from '@/common/utils/tenantSwitch';
// import V2InfiniteScrollList from '@/common/components/Data/V2InfiniteScrollList';
import InfiniteScroll from 'react-infinite-scroll-component';

const scrollableTarget = 'changeAccountScrollTable';

const ChangeAccount: React.FC<AccountModalProps> = forwardRef(({ setShowAccountModal, showAccountModal,
  isShareConfigToLogin,
}, ref) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [loading, setLoading] = useState<boolean>(false);
  const [enterprisesList, setEnterprisesList] = useState<any[]>([]);
  const [totalNum, setTotalNum] = useState<number>(0);
  const page = useRef<number>(1);
  const lockRef: any = useRef(false);
  useEffect(() => {
    showAccountModal && !isNotEmptyAny(enterprisesList) && methods.loadData();
  }, [showAccountModal]);

  useEffect(() => {
    if (isShareConfigToLogin && isShareConfigToLogin.id) {
      methods.intoHandle(isShareConfigToLogin);
    }

  }, [isShareConfigToLogin]);

  useEffect(() => {
    const originUrl = getLocxxExpansionReturnPath(window.location.pathname, window.location.search, window.location.hash);
    const targetTenantId = new URLSearchParams(window.location.search).get('tenantId');
    if (showAccountModal && originUrl && targetTenantId) {
      methods.intoHandle({ id: targetTenantId }, originUrl);
    }
  }, [showAccountModal]);

  // 获取企业信息
  // const getEnterprises = () => {
  //   tntList().then((data: any) => {
  //     setEnterprisesList(data);
  //     setLoading(false);
  //     if (isArray(data) && data.length === 1) {
  //       intoHandle(data[0]);
  //     }
  //   });
  // };

  const methods = useMethods({
    loadData() {
      console.log('loadData');
      if (loading) {
        return;
      }
      setLoading(true);

      tntPageList({ page: page.current, size: 20 }).then((res) => {
        const { objectList, totalNum } = res || {};

        // 如果只有一个企业，直接选择该企业
        if (totalNum === 1 && Array.isArray(objectList) && objectList.length === 1) {
          methods.intoHandle(objectList[0]);
        }

        setTotalNum(totalNum);
        if (isArray(objectList)) {
          setEnterprisesList(list => ([...list, ...objectList]));
          page.current = page.current + 1;
        }
      }).finally(() => {
        setLoading(false);
      });
    },

    // 选择企业
    async intoHandle(enterprise: any, originUrl?: string) {
      // 注意这里enterprise的传值，在分享配置场景下，这里的值里只有id可用
      const { id } = enterprise;
      originUrl = originUrl || getLocxxExpansionReturnPath(window.location.pathname, window.location.search, window.location.hash) || undefined;
      if (lockRef.current) return;
      lockRef.current = true;
      try {
        await switchTenant(id);
      } catch (error) {
        console.log(error);
        window.location.href = '/';
        return;
      } finally {
        lockRef.current = false;
      }
      bigdataFn('42851518-803b-4a7e-bc8a-bad9c78ec6c9', '登录按钮', '点击了登录');
      setTimeout(() => {
        // 如果是接入企业微信并且是H5需要登录后跳转到h5页面
        if (isMobile() && process.env.INSIGHT_URL) {
          window.location.href = process.env.INSIGHT_URL + `/home`;
        } else {
          window.location.href = originUrl || '/';
        }
      }, process.env.NODE_ENV === 'development' ? 100 : 200);
    },

    renderItem(item: any) {
      return (
        <List.Item onClick={methods.handleItemClick.bind(null, item)}>
          <List.Item.Meta
            description={
              <div className={cs(styles.flexItem)}>
                <div className={styles.imgBox}>
                  <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/new/icon_select_account.png`}/>
                </div>
                <div className={cs(styles.name, 'ft-28 c-666 ml-8 ellipsis')}>{item.name}</div>
                <RightOutlined className={cs(styles.rightArrow, 'pointer')} />
              </div>
            }
          />
        </List.Item>
      );
    },

    handleItemClick(item: any) {
      methods.intoHandle(item);
    }
  });

  useImperativeHandle(ref, () => ({
    intoHandle: methods.intoHandle
  }));

  return (
    <Modal
      open={showAccountModal}
      title='请选择租户'
      footer={false}
      onCancel={setShowAccountModal.bind(null, false)}
      width={480}
      className={styles.changeAccount}
      centered
    >
      <div className={styles.listWrap} id={scrollableTarget}>
        <InfiniteScroll
          dataLength={enterprisesList.length}
          next={methods.loadData}
          hasMore={enterprisesList.length < totalNum}
          scrollableTarget={scrollableTarget}
          endMessage={<Divider plain>暂无更多</Divider>}
          loader={<Skeleton paragraph={{ rows: 1 }} active />}
          height={408} // 必须要加高度，否则在弹窗内组件触底不生效
        >
          <List
            dataSource={enterprisesList}
            renderItem={methods.renderItem}
          />
        </InfiniteScroll>
      </div>
    </Modal>
  );
});

export default ChangeAccount;
